import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-1.component',
  templateUrl: './blank-1.component.html'
})
export class Blank1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
